
import React from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";

import desktopBanner from "../../assets/images/offer_banner1.webp";
import mobileBanner from "../../assets/images/offer_banner.webp";

const DETAIL_PATH = "/properties?location=Varthur";

const BhavanaArcadePromoPopup = ({ show, onClose }) => {
  const handleClose = () => onClose?.();

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop
      keyboard
      className="bhavana-arcade"
      dialogClassName="-dialog"
      contentClassName="bhavana-arcade-content"
    >
      <button
        type="button"
        className="bhavana-arcade-close"
        onClick={handleClose}
        aria-label="Close"
      >
        &times;
      </button>

      <Modal.Body className="p-0">
        <Link
          to={DETAIL_PATH}
          className="bhavana-arcade-image-link"
          onClick={handleClose}
        >
          <picture>
            <source
              media="(max-width: 576px)"
              srcSet={mobileBanner}
            />

            <img
              src={desktopBanner}
              alt="Bhavana Arcade Dussehra and Diwali 7% rental discount offer"
            />
          </picture>
        </Link>
      </Modal.Body>
    </Modal>
  );
};

export default BhavanaArcadePromoPopup;

